// Deep navy card background — matches live signnow.com (page-section--business-cloud-cta: #00134e).
// No exact design token exists for this navy; the closest is $color-brand-primary-darkest (#111f4b),
// but the live value intentionally differs, so it is used as a raw value here.
$cta-card-bg: #00134e;

.sn-cta-type-11 {
  &__content {
    overflow: hidden;
    border: 0;

    // Live business-cloud-cta card uses an 8px radius.
    border-radius: map-get($border-radii, md);
    background: $cta-card-bg;
    color: $color-neutral-white;

    > .me-row {
      margin-right: 0;
      margin-left: 0;
    }
  }

  .me-button--secondary,
  .me-button--primary {
    padding: map-get($spacings, sm) map-get($spacings, 2xl);
  }

  &__intro {
    text-align: center;

    &-inner {
      padding: map-get($spacings, 4xl) map-get($spacings, 2xl);

      @include above($breakpoint-desktop-md) {
        padding: 0 0 map-get($spacings, 5xl) map-get($spacings, 7xl);
        text-align: left;
      }
    }

    .me-text--label {
      .me-text {
        display: block;
        margin-bottom: map-get($spacings, md);
        text-transform: uppercase;
        letter-spacing: 3px;
        font-size: 10px;
        font-weight: map-get($font-weights, bold);

        @include desktop {
          font-size: map-get($font-sizes, xs);
        }
      }
    }

    .me-heading {
      font-size: map-get($font-sizes, 2xl);
      line-height: map-get($line-heights, lg);

      @include desktop {
        font-size: map-get($font-sizes, 5xl);
        line-height: map-get($line-heights, xl);
      }
    }
  }

  // Desktop: remove bottom margin from columns inside actions row
  @include desktop-lg {
    .sn-cta-type-11__actions.me-row > .me-column {
      margin-bottom: 0;
    }
  }

  &__actions {
    margin-top: map-get($spacings, lg);

    @include desktop {
      margin-top: map-get($spacings, 3xl);
    }
  }

  // Tablet (768px–960px): override grid → flex, buttons in one row, centered
  @include between($breakpoint-desktop, $breakpoint-desktop-md - 1px) {
    .sn-cta-type-11__actions.me-row {
      display: flex;
      justify-content: center;
      width: auto;
      margin-left: 0;
      margin-right: 0;
      gap: var(--spacing-md);

      > me-column {
        padding: 0;

        .me-button {
          width: auto;
        }
      }
    }
  }

  // Mobile (below 768px): keep grid stacked, center the container
  @include below-desktop {
    .sn-cta-type-11__actions.me-row {
      margin-left: auto;
      margin-right: auto;
    }

    .sn-cta-type-11__intro.me-column {
      margin-bottom: 0;
    }
  }

  &__media {
    display: none;

    @include above($breakpoint-desktop-md) {
      display: block;
    }

    &-inner {
      padding: map-get($spacings, 3xl);

      @include above($breakpoint-desktop-md) {
        padding: map-get($spacings, 5xl) map-get($spacings, 7xl) map-get($spacings, 5xl) 0;
      }
    }

    .cta-list {
      display: flex;
      flex-direction: column;
      gap: map-get($spacings, 3xl);

      .cta-list__item {
        display: flex;
        align-items: center;
        gap: map-get($spacings, xl);
      }

      .cta-list__logo {
        flex-shrink: 0;

        img,
        svg {
          width: 44px;
          height: 44px;
          min-width: 44px;
        }
      }

      .cta-list__description {
        font-family: Graphik, Arial, sans-serif;
        font-size: map-get($font-sizes, md);
        line-height: map-get($line-heights, md);

        @include desktop-lg {
          font-size: map-get($font-sizes, lg);
          line-height: map-get($line-heights, lg);
        }
      }
    }
  }

  // Opt-in: white rounded card behind each brand logo (matches the live block).
  &--logo-background {
    .cta-list__logo {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 44px;
      height: 44px;
      padding: map-get($spacings, xs);
      border-radius: map-get($border-radii, md);
      background-color: $color-neutral-white;
      box-shadow: 0 8px 40px rgb(0 0 0 / 10%);

      @include desktop-lg {
        width: 48px;
        height: 48px;
      }

      me-icon,
      .me-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      img,
      svg {
        width: 100%;
        height: 100%;
        min-width: 0;
        object-fit: contain;
      }
    }
  }
}
